<template>
  <!-- content -->
  <div class="content">
    <div class="title">
      <span class="fastReg">手机号已存在</span>
      <div class="name-content-scroll">
        <div
          class="business-check"
          v-for="(item, index) in companyList"
          :key="index"
        >
          <span
            class="yourCompany"
            :title="'您的手机号已经是' + item + '的联系人。'"
            >您的手机号已经是{{ item }}的联系人。</span
          >
          <el-button plain type="single-number" @click="toPerfectInfo(item)"
            >申请合作</el-button
          >
        </div>
      </div>
      <span class="fastReg companyReg">或者注册新公司</span>
    </div>
    <input
      maxlength="36"
      type="text"
      class="text"
      v-model="company"
      placeholder="请填写公司全称"
      @input="checkSupplierName"
    />
    <el-button class="errorbtn" dangerouslyUseHTMLString="false"
      >错误</el-button
    >
    <div class="regUpload" @click="goPage">立即注册</div>
  </div>
</template>

<script>
/* eslint-disable */
// import { Message } from "element-ui";
import { getReguser, getCompany, queryInfoBySupName } from  "../../../api/register.js";
export default {
  props: ["companyList"],
  data() {
    return {
      //message高度
      messageHeight: null,
      company: "",
      checkOut: {
        name: "",
        mobile: "",
        supplierName: "",
        regType: "0"
      }
    };
  },
  computed: {
    // testCompany() {
    //   return this.companyList.join(",");
    // }
  },
  mounted() {
    this.getBrowserHeight();
    this.$eventBus.$on("msg", res => {
      // console.log(res, "接受入参");
      this.checkOut.name = res.name;
      this.checkOut.mobile = res.mobile;
      // console.log(this.checkOut.name, ++this.checkOut.mobile);
    });
  },
  methods: {
    checkSupplierName() {
      this.company = this.company.replace(/[^\u4e00-\u9fa5\(\)\（\）]/g, "");
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    //直接申请合作
    toPerfectInfo(name) {
      queryInfoBySupName({
        mobile: this.checkOut.mobile,
        supplierName: name
      }).then(res => {
        if (res.data.code === "0") {
          console.log(name, "跳转到完善信息");
          this.checkOut.supplierName = name;
          this.checkOut.isShowLoading = true;
          this.checkOut.loadingMessage = "注册中,请稍等...";
          this.$emit("isExist", {
            flag: false,
            name: this.checkOut.supplierName
          });
          let jsonData = {
            name: this.checkOut.name,
            supplierName: this.checkOut.supplierName,
            mobile: this.checkOut.mobile
          };
          this.$eventBus.$emit("toPerfectInfoByName", jsonData);
        }
      });
    },
    // 点击
    goPage() {
      if (!this.company) {
        this.$message({
          showClose: true,
          message: "请填写公司全称",
          type: "warning",
          offset: this.messageHeight
        });
      } else {
        let checkName = /^[\u4e00-\u9fa5\(\)\（\）]+$/;
        if (!checkName.test(this.company)) {
          this.$message({
            showClose: true,
            message: "请填写正确的公司全称",
            type: "warning",
            offset: this.messageHeight
          });
          return false;
        }
        this.checkOut.supplierName = this.company;
        this.checkOut.isShowLoading = true;
        this.checkOut.loadingMessage = "注册中,请稍等...";
        getReguser(this.checkOut).then(res => {
          console.log(res, "=-=-=-=-=");
          if (res.data.data.flag !== "") {
            if (res.data.data.flag === "1") {
              console.log("jinlai");
              this.$emit("approval", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile,
                contentReg:
                  "已提交了开店申请，请等待审批结果通过后，再向合作单位发起合作申请，感谢您的申请。"
              };
              this.$eventBus.$emit("beenApprovaling", jsonData);
            } else {
              console.log("jinlai");
              this.$emit("approval", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile,
                contentReg: "正在合作申请中，不能重复申请。"
              };
              this.$eventBus.$emit("beenApprovaling", jsonData);
            }
          } else {
            if (res.data.data.exist === true) {
              this.$emit("isExist", {
                flag: true,
                name: this.checkOut.supplierName
              });
              let jsonData = {
                name: this.checkOut.name,
                supplierName: this.checkOut.supplierName,
                contactId: res.data.data.contactId,
                mobile: this.checkOut.mobile
              };
              this.$eventBus.$emit("beenReg", jsonData);
            } else {
              getCompany({
                mobile: this.checkOut.mobile,
                supplierName: this.checkOut.supplierName,
                // supplierName: "北京国际信托有限公司",
                isShowLoading: true
              }).then(res => {
                if (res.data.code === "0") {
                  this.$emit("isExist", {
                    flag: false,
                    name: this.checkOut.supplierName
                  });
                  let jsonData = {
                    name: this.checkOut.name,
                    supplierName: this.checkOut.supplierName,
                    contactId: res.data.data.contactId,
                    mobile: this.checkOut.mobile
                  };
                  this.$eventBus.$emit("supplierName", jsonData);
                }
              });
            }
          }
        });
        // getCheckCompany({ shopName: this.company }).then(res => {
        //   if (res.data.exist) {
        //     this.$emit("isExist", {
        //       flag: true,
        //       name: this.company
        //     });
        //   } else {
        //     this.$emit("isExist", {
        //       flag: false,
        //       name: this.company
        //     });
        //   }
        // });
      }
    }
  }
};
</script>

<style scoped lang="scss">
html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
.title {
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.content {
  width: 1180px;
  min-height: calc(100vh - 290px);
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
}
.fastReg {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  padding-bottom: 12px;
}
.companyReg {
  padding-top: 32px;
}
.regUpload {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
  margin-top: 24px;
  text-align: center;
  line-height: 40px;
}
.errorbtn {
  display: none;
  position: absolute;
}
.text {
  width: 500px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 40px;
  padding-left: 10px;
}
.yourCompany {
  font-size: 13px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
}
.name-content-scroll {
  width: 500px;
  max-height: 100px;
  overflow-y: auto;
  padding-right: 20px;
}
.business-check {
  font-size: 13px;
  color: #4a4a4a;
  line-height: 17px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
/deep/ .el-button {
  background: #ffffff;
  border-color: #ff142f;
  span {
    color: #ff142f;
  }
  &:hover,
  &:active {
    border-color: #ff142f !important;
    background-color: #ffedef !important;
  }
  &:focus {
    border-color: #ff142f !important;
  }
}
</style>
